"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../gen-src/Localize");
var DeviceIcons_1 = require("./icons/DeviceIcons");
var getStyles = function () {
    return {
        LaptopIcon: {
            height: DeviceIcons_1.DeviceLaptopIcon.height,
            width: DeviceIcons_1.DeviceLaptopIcon.width,
        },
        TabletIcon: {
            height: DeviceIcons_1.DeviceTabletIcon.height,
            width: DeviceIcons_1.DeviceTabletIcon.width,
        },
        PhoneIcon: {
            height: DeviceIcons_1.DevicePhoneIcon.height,
            width: DeviceIcons_1.DevicePhoneIcon.width,
        },
    };
};
var AvailableDevices;
(function (AvailableDevices) {
    AvailableDevices["Laptop"] = "Laptop";
    AvailableDevices["Tablet"] = "Tablet";
    AvailableDevices["Phone"] = "Phone";
})(AvailableDevices = exports.AvailableDevices || (exports.AvailableDevices = {}));
var AvailableDeviceLayouts = /** @class */ (function (_super) {
    __extends(AvailableDeviceLayouts, _super);
    function AvailableDeviceLayouts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AvailableDeviceLayouts.prototype.render = function () {
        var availableDevices = this.props.availableDevices;
        if (availableDevices === null || availableDevices === undefined || availableDevices.length === 0) {
            // tslint:disable-next-line:no-console
            console.debug('No device layouts to render');
            return null;
        }
        else {
            return this.renderAllDevices();
        }
    };
    AvailableDeviceLayouts.prototype.disableContextMenu = function (e) {
        e.preventDefault();
    };
    AvailableDeviceLayouts.prototype.renderAllDevices = function () {
        var _this = this;
        var availableDevices = this.props.availableDevices;
        var deviceIcons = availableDevices.map(function (device) {
            return _this.renderOneDevice(device);
        });
        return React.createElement("div", { onContextMenu: this.disableContextMenu }, deviceIcons);
    };
    AvailableDeviceLayouts.prototype.renderOneDevice = function (device) {
        if (device === AvailableDevices.Laptop) {
            return this.createImage('LaptopIcon', getStyles().LaptopIcon, DeviceIcons_1.DeviceLaptopIcon.enabled, Localize_1.Messages.AvailableDeviceLayoutsLaptop());
        }
        else if (device === AvailableDevices.Tablet) {
            return this.createImage('TabletIcon', getStyles().TabletIcon, DeviceIcons_1.DeviceTabletIcon.enabled, Localize_1.Messages.AvailableDeviceLayoutsTablet());
        }
        else if (device === AvailableDevices.Phone) {
            return this.createImage('PhoneIcon', getStyles().PhoneIcon, DeviceIcons_1.DevicePhoneIcon.enabled, Localize_1.Messages.AvailableDeviceLayoutsPhone());
        }
        console.error('Unrecognized device layout: ' + device);
        return null;
    };
    AvailableDeviceLayouts.prototype.createImage = function (className, style, imageSource, title) {
        return React.createElement(widgets_1.Img, { className: className, key: className, style: style, src: imageSource, title: title });
    };
    return AvailableDeviceLayouts;
}(React.Component));
exports.AvailableDeviceLayouts = AvailableDeviceLayouts;
//# sourceMappingURL=AvailableDeviceLayouts.js.map